import api from '@/api/axiosConfig.js';

const branchParams = (sucursalId) => (sucursalId ? { sucursal_id: sucursalId } : {});

// A 2xx answer without the expected envelope (a proxy or login page, an old
// server) must surface as an error instead of rendering an empty dashboard.
const dashboardPayload = (response, requiredKeys, label) => {
  const data = response?.data?.data;
  if (!data || typeof data !== 'object' || requiredKeys.some((key) => !(key in data))) {
    throw new Error(`La respuesta del ${label} no tiene el formato esperado.`);
  }
  return data;
};

const CARGAS_KEYS = ['kpis', 'lineas', 'repartos', 'entregas', 'retiros', 'fojasSinSalida', 'guiasPorDestino', 'actividadPorHora'];
const GERENCIAL_KEYS = ['executiveHeader', 'executiveOverview', 'executiveKpis', 'operationalFunnel', 'branchStatus', 'criticalAlerts', 'financialSummary', 'productivityRanking', 'monthlyComparison'];

export async function fetchDashboardCargas({ sucursalId } = {}) {
  const response = await api.get('/api/dashboards/cargas', { params: branchParams(sucursalId) });
  return dashboardPayload(response, CARGAS_KEYS, 'tablero de cargas');
}

export async function fetchDashboardGerencial({ sucursalId } = {}) {
  const response = await api.get('/api/dashboards/gerencial', { params: branchParams(sucursalId) });
  return dashboardPayload(response, GERENCIAL_KEYS, 'tablero gerencial');
}
